<template>
    <cs-app>
      <template v-slot:content>
          <router-link :to="{name: 'lawyer.cases.index'}" style="align-self: flex-start;">
              <md-button class="default">
                  <md-icon>chevron_left</md-icon>Back
              </md-button>
          </router-link>
          <h1>404 Page Not Found</h1>
      </template>
    </cs-app>
</template>

<script>
import CSApp from '@/components/CSApp'

export default {
  components: {
    'cs-app': CSApp,
  }
}
</script>

